export const FAKESHIELD_DTE_BASE_URL = 'https://8f6e3b1b3d35ca087f.gradio.live'

export const FAKESHIELD_MFLM_BASE_URL = 'https://08db946354ed329756.gradio.live'

export const STEP1X_BASE_URL = 'https://6957fd8035c03e5d50.gradio.live'